// js
AOS.init();

$(document).ready(function() {


  if ($(window).width() < 992 ) {
    $(".hamburger, .box-menu, .box-lang a, .menu-li").click(function() {
      $(this).toggleClass("is-active");
      $(".box-menu").toggleClass("open");
    });
  }

  // $(window).resize(function() {
  //   if ($(this).width() < 992 ) {
  //     $(".hamburger").click(function() {
  //       $(this).toggleClass("is-active");
  //       $(".box-menu").toggleClass("open");
  //     });
  //   }
  // });


  $(".btn-lang").click(function(e) {
    $(this).toggleClass("selected");
    e.stopPropagation();
  });

  $(document).click(function(e) {
    if ($(e.target).is(".btn-lang") === false) {
      $(".btn-lang").removeClass("selected");
    }
  });





  // Add smooth scrolling to all links
  $("a").on('click', function(event) {
    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();
      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 1000, function(){

        // Add hash (#) to URL when done scrolling (default click behavior)
        // window.location.hash = hash;
      });
    } // End if
  });


  // if ($('.go-to-top').length) {
  //   var scrollTrigger = 1000, // px
  //   backToTop = function () {
  //     var scrollTop = $(window).scrollTop();
  //   };
  //   backToTop();
  //   $(window).on('scroll', function () {
  //     backToTop();
  //   });
  //   $('.go-to-top').on('click', function (e) {
  //     e.preventDefault();
  //     $('html,body').animate({
  //       scrollTop: 0
  //     }, 700);
  //   });
  // }

  $('.carousel-videos').flickity({
    pageDots: false,
    draggable: false,
    fade: true,
    cellAlign: 'left',
    arrowShape: 'M1.15,52.76h0L21.56,73.08a3.91,3.91,0,0,0,5.51-5.54L13.37,53.91H96.09a3.91,3.91,0,0,0,0-7.82H13.37l13.7-13.63a3.91,3.91,0,0,0-5.51-5.54L1.15,47.23h0a3.9,3.9,0,0,0,0,5.53Z'
  });

  if ($(window).width() < 992 ) {
    $('.carousel-projetos').flickity({
      pageDots: false,
      groupCells: true,
      cellAlign: 'left',
      arrowShape: 'M1.15,52.76h0L21.56,73.08a3.91,3.91,0,0,0,5.51-5.54L13.37,53.91H96.09a3.91,3.91,0,0,0,0-7.82H13.37l13.7-13.63a3.91,3.91,0,0,0-5.51-5.54L1.15,47.23h0a3.9,3.9,0,0,0,0,5.53Z'
    });

  } else {
    $('.carousel-projetos').flickity({
      pageDots: false,
      groupCells: true,
      draggable: false,
      cellAlign: 'left',
      arrowShape: 'M1.15,52.76h0L21.56,73.08a3.91,3.91,0,0,0,5.51-5.54L13.37,53.91H96.09a3.91,3.91,0,0,0,0-7.82H13.37l13.7-13.63a3.91,3.91,0,0,0-5.51-5.54L1.15,47.23h0a3.9,3.9,0,0,0,0,5.53Z'
    });
  }

  $('.carousel-fotos').flickity({
    pageDots: false,
    contain: true,
    cellAlign: 'left',
    draggable: false,
    imagesLoaded: true,
    arrowShape: 'M1.15,52.76h0L21.56,73.08a3.91,3.91,0,0,0,5.51-5.54L13.37,53.91H96.09a3.91,3.91,0,0,0,0-7.82H13.37l13.7-13.63a3.91,3.91,0,0,0-5.51-5.54L1.15,47.23h0a3.9,3.9,0,0,0,0,5.53Z'
  });



  $('.hero-home-carousel').flickity({
    cellSelector: '.hero-home-carousel-cell',
    pageDots: false,
    prevNextButtons: false,
    // contain: true,
    cellAlign: 'left',
    draggable: false,
    imagesLoaded: true,
    autoPlay: 4000,
    pauseAutoPlayOnHover: false,
    fade: true
    // arrowShape: 'M1.15,52.76h0L21.56,73.08a3.91,3.91,0,0,0,5.51-5.54L13.37,53.91H96.09a3.91,3.91,0,0,0,0-7.82H13.37l13.7-13.63a3.91,3.91,0,0,0-5.51-5.54L1.15,47.23h0a3.9,3.9,0,0,0,0,5.53Z'
  });

 

  // YOUTUBE PLAYER

  //   $('.carousel-videos .carousel-cell').click(function() {
  //
  //
  //     // if ($(this).parent().hasClass('playing')) {
  //     //   $(this).parent().parent().removeClass('hide-navigation');
  //     //   $(this).parent().removeClass('playing');
  //     //   $(this).children('.poster, .btn-controls').removeClass('hide');
  //     // } else {
  //       $(this).parent().parent().addClass('hide-navigation');
  //       $(this).parent().addClass('playing');
  //       $(this).children('.poster, .btn-controls').addClass('hide');
  //     // }
  //
  // });


  // $('.btn-controls').click(function() {
  //   if ($(this).hasClass('hide')) {
  //     $(this).remove('hide');
  //   }
  // });


  // });

  $('.carousel-videos .carousel-cell').click(function(){
    if ($(this).hasClass('playing')) {
      $(this).parent().removeClass('hide-navigation');
      $(this).removeClass('playing');
      $(this).children('.btn-controls, .poster').removeClass('hide');
    } else {
      $(this).parent().addClass('hide-navigation');
      $(this).addClass('playing');
      $(this).children('.poster, .btn-controls').addClass('hide');
    }
  });

  $('.carousel-videos .carousel-cell.arquivo-cell').click(function(){
    if ($(this).hasClass('playing')) {
      $(this).children('video').get(0).play();
    } else {
      $(this).children('video').get(0).pause();
    }
  });

  $('.carousel-videos .carousel-cell.youtube-cell').click(function(){
    if ($(this).hasClass('playing')) {
      $(this).children('.video-frame').attr('src', $(this).children('.video-frame').attr('src') + '?autoplay=1');
      $(this).children('.btn-controls').addClass('d-none');
    }
  });


  var $carousel = $('.carousel-videos');

  $carousel.on( 'change.flickity', function( event, index ) {
    $('.carousel-videos .carousel-cell').removeClass('playing');
    if ($('.carousel-videos .carousel-cell.youtube-cell').length) {
      $('.carousel-videos .carousel-cell.youtube-cell .btn-controls').removeClass('d-none');
      $('.carousel-videos .carousel-cell.youtube-cell').each(function(){
        var lala = $(this).children('.video-frame').attr('src');
        var final = lala.replace("?autoplay=1","");
        $(this).children('.video-frame').attr('src', final);
      });
    }

    if ($('.carousel-videos .carousel-cell.arquivo-cell').length) {
      $('.carousel-videos .carousel-cell.arquivo-cell video').get(0).pause();
    }
    $('.carousel-videos .carousel-cell .btn-controls, .carousel-videos .carousel-cell .poster').removeClass('hide');
    $('.carousel-videos').removeClass('hide-navigation');
  });

  if ($(window).width() > 991 ) {
    $(".carousel-videos .carousel-cell, .flickity-button").mouseover(function() {
      if ($('.carousel-videos .carousel-cell').hasClass('playing')) {
        $('.carousel-videos').removeClass('hide-navigation');
      }
    }).mouseout(function() {
      if ($('.carousel-videos .carousel-cell').hasClass('playing')) {
        $('.carousel-videos').addClass('hide-navigation');
      }
    });
  }

  $('.carousel-videos .carousel-cell.arquivo-cell video').on('ended', function(){
    $(this).parent().removeClass('playing');
    $(this).get(0).pause();
    $(this).siblings('.btn-controls, .poster').removeClass('hide');
    $('.carousel-videos').removeClass('hide-navigation');
  });

  $('.carousel-videos .carousel-cell.arquivo-cell video').on('pause', function(){
    $(this).parent().removeClass('playing');
    $(this).get(0).pause();
    $(this).siblings('.btn-controls, .poster').removeClass('hide');
    $('.carousel-videos').removeClass('hide-navigation');
  });


  //////////////


  $(window).scroll(function() {
    var scroll = $(window).scrollTop();

    if ( !$('.hero-archive-projetos').length) {
      if (scroll >= 400) {
        $('header').addClass('sticky');
      }
      else if (scroll < 400) {
        $('header').removeClass('sticky');
      }
    } else {
      if (scroll >= 100) {
        $('header').addClass('sticky');
      }
      else if (scroll <100) {
        $('header').removeClass('sticky');
      }
    }


  });




  // video background
  //
  // var min_w = 300;
  // var vid_w_orig;
  // var vid_h_orig;
  //
  // $(function() {
  //
  //   vid_w_orig = parseInt($('video').attr('width'));
  //   vid_h_orig = parseInt($('video').attr('height'));
  //
  //   $(window).resize(function () { fitVideo(); });
  //   $(window).trigger('resize');
  //
  // });
  //
  // function fitVideo() {
  //
  //   $('#video-viewport').width($('.fullsize-video-bg').width());
  //   $('#video-viewport').height($('.fullsize-video-bg').height());
  //
  //   var scale_h = $('.fullsize-video-bg').width() / vid_w_orig;
  //   var scale_v = $('.fullsize-video-bg').height() / vid_h_orig;
  //   var scale = scale_h > scale_v ? scale_h : scale_v;
  //
  //   if (scale * vid_w_orig < min_w) {scale = min_w / vid_w_orig;};
  //
  //   $('video').width(scale * vid_w_orig);
  //   $('video').height(scale * vid_h_orig);
  //
  //   $('#video-viewport').scrollLeft(($('video').width() - $('.fullsize-video-bg').width()) / 2);
  //   $('#video-viewport').scrollTop(($('video').height() - $('.fullsize-video-bg').height()) / 2);
  //
  // }


  $('.glink').click(function(){
    $(this).addClass('active').siblings().removeClass('active');
  });

  //filtro

  if ($('.hero-archive-projetos').length) {

    // init Isotope
    var $grid = $('.grid').isotope({
      itemSelector: '.post-item',
      layoutMode: 'fitRows',
      // transitionDuration: '0.8s',
      hiddenStyle: {
        opacity: 0
      },
      visibleStyle: {
        opacity: 1
      }
    });
    // filter functions
    var filterFns = {};
    // bind filter button click
    $('.btn-filter').on( 'click', function() {
      $( this ).addClass('is-checked').siblings().removeClass('is-checked');
      // $('.loading-content').addClass('show');

      var filterValue = $( this ).attr('data-filter');
      // use filterFn if matches value
      filterValue = filterFns[ filterValue ] || filterValue;
      $grid.isotope({ filter: filterValue });

      var elems = $grid.isotope('getFilteredItemElements');
      $(elems).siblings().removeClass('is-filtered');
      $(elems).addClass('is-filtered');

      var qtd_elemns = elems.length;

      var i;

      $(elems).nextAll('.is-filtered').eq(0).addClass('col-lg-5').removeClass('col-lg-7').removeClass('col-lg-12').removeClass('bigger-height');


      for (i = 1; i <= qtd_elemns; i += 5) {
        console.log(i);
        $(elems).nextAll('.is-filtered').eq(i).addClass('col-lg-5').removeClass('col-lg-7').removeClass('col-lg-12').removeClass('bigger-height');
      }

      for (i = 2; i <= qtd_elemns; i += 5) {
        console.log(i);
        $(elems).nextAll('.is-filtered').eq(i).addClass('col-lg-7').removeClass('col-lg-5').removeClass('col-lg-12').removeClass('bigger-height');
      }
      for (i = 3; i <= qtd_elemns; i += 5) {
        console.log(i);
        $(elems).nextAll('.is-filtered').eq(i).addClass('col-lg-12').removeClass('col-lg-7').removeClass('col-lg-5').addClass('bigger-height');
      }
      for (i = 4; i <= qtd_elemns; i += 5) {
        console.log(i);
        $(elems).nextAll('.is-filtered').eq(i).addClass('col-lg-7').removeClass('col-lg-5').removeClass('col-lg-12').removeClass('bigger-height');
      }
      for (i = 5; i <= qtd_elemns; i += 5) {
        console.log(i);
        $(elems).nextAll('.is-filtered').eq(i).addClass('col-lg-5').removeClass('col-lg-7').removeClass('col-lg-12').removeClass('bigger-height');
      }


      $(elems).first().addClass('col-lg-7').removeClass('col-lg-5').removeClass('col-lg-12').removeClass('bigger-height');

    });


    //****************************
    // Isotope Load more button
    //****************************
    if ( $(window).width() > 992) {
      var number_of_posts = 9;
    } else {
      var number_of_posts = 5;
    }
    var initShow = number_of_posts; //number of items loaded on init & onclick load more button
    var counter = initShow; //counter for load more button
    var iso = $grid.data('isotope'); // get Isotope instance
    loadMore(initShow); //execute function onload

    function loadMore(toShow) {
      // setTimeout(function()  {
      $grid.find(".hidden").removeClass("hidden");
      // }, 1000);


      var hiddenElems = iso.filteredItems.slice(toShow, iso.filteredItems.length).map(function(item) {
        return item.element;
      });
      $(hiddenElems).addClass('hidden');
      $grid.isotope('layout');

      //when no more to load, hide show more button
      if (hiddenElems.length == 0) {
        jQuery("#load-more-projetos").hide();
      } else {
        jQuery("#load-more-projetos").show();
      };

    }

    //append load more button
    // $grid.after('<button id="teste"> Load More</button>');

    //when load more button clicked
    $("#load-more-projetos").click(function() {
      if ($('.btn-filter').data('clicked')) {
        //when filter button clicked, set initial value for counter
        counter = initShow;
        $('.btn-filter').data('clicked', false);
      } else {
        counter = counter;
      };

      counter = counter + initShow;

      loadMore(counter);

    });

    //when filter button clicked
    $(".btn-filter").click(function() {
      $(this).data('clicked', true);

      loadMore(initShow);
    });

  }

});
